import Vue from 'vue'
import Router from 'vue-router'
import BecomeScreen from '@/components/BecomeScreen'
import LoginScreen from '@/components/LoginScreen'
import LogoutScreen from '@/components/LogoutScreen'
import ResetPasswordScreen from '@/components/ResetPasswordScreen'
import OnboardingScreen from '@/components/OnboardingScreen'
import OnboardingSuccessScreen from '@/components/OnboardingSuccessScreen'
import EditScreen from '@/components/EditScreen'
import BlackboardScreen from '@/components/BlackboardScreen'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/edit'
    },
    {
      path: '/login',
      name: 'login',
      component: LoginScreen
    },
    {
      path: '/logout',
      name: 'logout',
      component: LogoutScreen
    },
    {
      path: '/become',
      component: BecomeScreen
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPasswordScreen
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: OnboardingScreen
    },
    {
      path: '/onboarding/success',
      name: 'onboarding-success',
      props: { showHousebookControlLink: false },
      component: OnboardingSuccessScreen
    },
    {
      path: '/onboarding/success-admin',
      name: 'onboarding-success-admin',
      props: { showHousebookControlLink: true },
      component: OnboardingSuccessScreen
    },
    {
      path: '/edit',
      name: 'edit',
      component: EditScreen
    },
    {
      path: '/blackboard',
      name: 'blackboard',
      component: BlackboardScreen
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js